export default {
  setPractices(state, payload) {
    state.practices = payload;
  },
  deletePractice(state, payload) {
    if (!state.practices?.data) return;
    const removeIndex = state.practices.data.findIndex(
      (item) => item.id === payload
    );
    if (removeIndex !== -1) {
      state.practices.data.splice(removeIndex, 1);
      state.practices.total = Math.max(0, (state.practices.total || 1) - 1);
    }
  },
  setUser(state, payload) {
    state.users = payload;
  },
  deleteUser(state, payload) {
    const removeIndex = state.users.data.findIndex(
      (item) => item.id === payload
    );
    state.users.data.splice(removeIndex, 1);
  },
  setPolicies(state, payload) {
    state.policies = payload;
  },
  deletePolicy(state, payload) {
    const removeIndex = state.policies.findIndex((item) => item.id === payload);
    state.policies.splice(removeIndex, 1);
  },
  setRoles(state, payload) {
    state.roles = payload;
  },
  setRoleOptions(state, payload) {
    state.roleOptions = payload;
  },
  deleteRole(state, payload) {
    if (!state.roles?.data) return;
    const removeIndex = state.roles.data.findIndex(
      (item) => item.id === payload
    );
    if (removeIndex !== -1) {
      state.roles.data.splice(removeIndex, 1);
      state.roles.total = Math.max(0, (state.roles.total || 1) - 1);
    }
    state.roleOptions = (state.roleOptions || []).filter(
      (item) => item.code !== payload
    );
  },
  setPermissions(state, payload) {
    state.permissions = payload;
  },
  deletePermissions(state, payload) {
    if (!state.permissions?.data) return;
    const removeIndex = state.permissions.data.findIndex(
      (item) => item.id === payload
    );
    if (removeIndex !== -1) {
      state.permissions.data.splice(removeIndex, 1);
      state.permissions.total = Math.max(
        0,
        (state.permissions.total || 1) - 1
      );
    }
  },
  setRooms(state, payload) {
    state.rooms = payload;
  },
  deleteRooms(state, payload) {
    const removeIndex = state.rooms.data.findIndex(
      (item) => item.id === payload
    );
    state.rooms.data.splice(removeIndex, 1);
  },
  setReasons(state, payload) {
    state.reasons = payload;
  },
  deleteReasons(state, payload) {
    if (!state.reasons?.data) return;
    const removeIndex = state.reasons.data.findIndex(
      (item) => item.id === payload
    );
    if (removeIndex !== -1) {
      state.reasons.data.splice(removeIndex, 1);
      state.reasons.total = Math.max(0, (state.reasons.total || 1) - 1);
    }
  },
};
